import React, { useContext, useEffect } from 'react'
import pclnExperimentation from '@pcln/experimentation'
import ExperimentContext from '../../context/ExperimentContext'
import { childByTagOr } from './experiment-helpers'

const Experiment = ({ children }: { children: React.ReactNode }) => (
  <>{children}</>
)

const Original = ({ children }: { children: React.ReactNode }) => (
  <>{children}</>
)

function ConditionalRender({
  experimentCode,
  variantValue,
  children,
  experiment,
  original,
  triggerExperiment = () => true
}: {
  experimentCode: string
  variantValue?: string
  children?: React.ReactNode
  experiment?: any
  original?: any
  triggerExperiment?: () => boolean
}) {
  const { [experimentCode]: setiTest = 'DEFAULT' } = useContext(
    ExperimentContext
  )

  const shouldTriggerExperiment = triggerExperiment()
  useEffect(() => {
    if (shouldTriggerExperiment) {
      pclnExperimentation.fireImpression(experimentCode)
    }
  }, [experimentCode, setiTest, shouldTriggerExperiment])

  const callVariant =
    (setiTest === variantValue ||
      (setiTest !== 'DEFAULT' && setiTest !== 'CONTROL')) &&
    shouldTriggerExperiment

  return callVariant
    ? childByTagOr(experiment, children, Experiment)
    : childByTagOr(original, children, Original)
}

ConditionalRender.Experiment = Experiment
ConditionalRender.Original = Original

export { ConditionalRender as default, Experiment, Original }
